import {buildCommonGridActionTypes} from "./commonGridATBuilder";
import {buildCommonEditorActionTypes} from "./commonEditorATBuider";

export const CENTERS_GRID = buildCommonGridActionTypes('CENTERS');

export const CENTERS_EDITOR = buildCommonEditorActionTypes('CENTERS');

export const CENTERS_IMAGES_EDITOR = 'IMAGES';

export const CENTERS_LIST_IMAGE_EDITOR = 'LIST_IMAGE';